import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiX } from 'react-icons/fi';

const SuccessToast = ({ isVisible, message, onClose, autoCloseDelay = 5000 }) => {
  useEffect(() => {
    if (isVisible && autoCloseDelay > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [isVisible, autoCloseDelay, onClose]);

  return (
    <div className="fixed top-5 right-5 z-50">
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ type: "spring", damping: 20, stiffness: 300 }}
            className="bg-green-500 text-white rounded-lg shadow-lg p-4 flex items-center space-x-3 min-w-[250px]"
          >
            <FiCheckCircle className="w-6 h-6 flex-shrink-0" />
            <span className="flex-1 text-sm font-medium">
              {message || "Your message has been sent successfully!"}
            </span>
            <button
              onClick={onClose}
              className="p-1 rounded-full hover:bg-white/20 transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SuccessToast;
